// React
import React from "react";

/**
 * Static label above a field, with hint or error below (.field-label / .field-hint /
 * .field-error of styles/global.css). The error replaces the hint.
 */
export default function FormField({
  label,
  htmlFor,
  required,
  hint,
  error,
  className = "",
  children,
}) {
  return (
    <div className={className}>
      {label && (
        <label className="field-label" htmlFor={htmlFor}>
          {label}
          {required && (
            <span className="ml-0.5 text-danger" aria-hidden="true">
              *
            </span>
          )}
        </label>
      )}
      {children}
      {error ? (
        <p className="field-error" role="alert">
          {error}
        </p>
      ) : hint ? (
        <p className="field-hint">{hint}</p>
      ) : null}
    </div>
  );
}
